/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CspMonthlyPoint
 */
export interface CspMonthlyPoint {
  /**
   * Month label, e.g. "Jan 2026".
   * @type {string}
   * @memberof CspMonthlyPoint
   */
  month: string;
  /**
   *
   * @type {number}
   * @memberof CspMonthlyPoint
   */
  quoted: number;
  /**
   *
   * @type {number}
   * @memberof CspMonthlyPoint
   */
  booked: number;
  /**
   *
   * @type {number}
   * @memberof CspMonthlyPoint
   */
  paidCad: number;
}

/**
 * Check if a given object implements the CspMonthlyPoint interface.
 */
export function instanceOfCspMonthlyPoint(
  value: object,
): value is CspMonthlyPoint {
  if (!("month" in value) || value["month"] === undefined) return false;
  if (!("quoted" in value) || value["quoted"] === undefined) return false;
  if (!("booked" in value) || value["booked"] === undefined) return false;
  if (!("paidCad" in value) || value["paidCad"] === undefined) return false;
  return true;
}

export function CspMonthlyPointFromJSON(json: any): CspMonthlyPoint {
  return CspMonthlyPointFromJSONTyped(json, false);
}

export function CspMonthlyPointFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CspMonthlyPoint {
  if (json == null) {
    return json;
  }
  return {
    month: json["month"],
    quoted: json["quoted"],
    booked: json["booked"],
    paidCad: json["paidCad"],
  };
}

export function CspMonthlyPointToJSON(json: any): CspMonthlyPoint {
  return CspMonthlyPointToJSONTyped(json, false);
}

export function CspMonthlyPointToJSONTyped(
  value?: CspMonthlyPoint | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    month: value["month"],
    quoted: value["quoted"],
    booked: value["booked"],
    paidCad: value["paidCad"],
  };
}
